// Pathify
import { make } from 'vuex-pathify'
import axios from 'axios'
import router from '@/router'
import AuthService from './auth/auth.service'
//import * as auth from '../services'

//https://github.com/bezkoder/vue-vuex-jwt-auth/blob/master/src/store/index.js
//https://github.com/bezkoder/node-js-jwt-authentication-postgresql/blob/master/app/controllers/auth.controller.js


/*const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };*/

const state = {
  username: '',
  email: '',
  password: '',
  user: JSON.parse(localStorage.getItem('user')),
  initialState: {},
  loggedIn: false,
  message: ''
}

const mutations = {
  /*setAccount(state, payload) {
    state.username = payload.username;
    state.email = payload.email;
    state.password = payload.password;
  }*/
    loginSuccess(state, user) {
      state.loggedIn = true;
      state.user = user;
      state.username = user.username;
      state.message = '';
    },
    loginFailure(state) {
      state.loggedIn = false;
      state.user = null;
    },
    setMessage(state, mess){
      state.message = mess;
    },
    logout(state) {
      state.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.loggedIn = false;
    },
    registerFailure(state) {
      state.loggedIn = false;
    },
    setInitialState(state) {
      state.initialState = user
      ? { loggedIn: true , user }
      : { loggedIn: false , user: null }
    },
}

const actions = {
    login( { commit }, payload) {
      try{
        axios.post('/api/signin', payload).then(response => {
            if(response.data.message !== 'User Not found.'){
                //console.log('login  store SUCCESS', response);
                if (response.data.accessToken) {
                  localStorage.setItem('user', JSON.stringify(response.data));
                  commit('loginSuccess', response.data);
                }

                return response.data;
            }else{
                commit('loginFailure');
                commit('setMessage',response.data.message);
                return null;
            }
            

        }).catch(error => {
              //console.log('login store FAIL', error.response.data.message);
              commit('setMessage',error.response.data.message);
              commit('loginFailure');
          });
      } catch(error){
          console.log('login store FAIL');
          commit('setMessage',error.response.data.message);
          commit('loginFailure');
      }

      /*return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );*/

    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    /*register({ commit }, payload) {
        return axios.post('/api/signup', {
          username: payload.username,
          email: payload.email,
          password: payload.password
        }).then(
            response => {
              commit('registerSuccess');
              return Promise.resolve(response.data);
            },
            error => {
              commit('registerFailure');
              return Promise.reject(error);
            }
        );
      },*/
    /*register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    }*/
}

const getters = {
  username: state => {
    return state.username
  },
  email: state => {
    return state.email
  },
  password: state => {
    return state.password
  },
  initialState: state => {
    return state.initialState
  },
  loggedIn: state => {
    return state.loggedIn
  },
  message: state => {
    return state.message
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
